<template>
  <div>
    <BaseTopLine>
      <div class="d-flex gap-10 align-items-center">
        <div class="btn btn-sm btn-primary" @click="openModalForCreate('promocodesAdminModal')">
          Добавить
        </div>
        <div class="btn btn-sm btn-opposite" @click="deleteActionAndModal">
          Удалить
        </div>
      </div>
    </BaseTopLine>
    <div class="p-20">
      <BasePagination :page-count="numPages" :page-range="3" :margin-pages="2" :break-view-class="'d-none'"
        :click-handler="clickLoadData" :prev-text="'Назад'" :next-text="'Далее'"
        :container-class="'pagination pagination-sm'" :page-class="'page-item'" :pageLinkClass="'page-link'">
      </BasePagination>

      <BaseReuseTable :props-data="promocodesAdminData" :props-columns-setting="fieldsTablePromocodesAdmin"
        :selectRowActivateFlag="true" :modalActivateFlag="true" nameForAction="promocodesAdminModal"
        v-if="promocodesAdminLoadStatus == 'success'">
      </BaseReuseTable>
    </div>
    <Teleport to="body">
      <Modal nameForAction="promocodesAdminModal" @closeModal="closeModal">
        <div class="p-10">
          <BaseInput placeholder="" title="" @onInput="updateValue" :value="dataForModal.promocodes__code"
            name-sign="Код" input-name="promocodes__code">
          </BaseInput>
          <BaseTextarea placeholder="" title="" @onInput="updateValue" :value="dataForModal.promocodes__description"
            name-sign="Описание" input-name="promocodes__description">
          </BaseTextarea>
          <BaseInput placeholder="" title="" @onInput="updateValue" :value="dataForModal.promocodes__starts"
            name-sign="Дата начала" input-name="promocodes__starts" input-type="datetime-local">
          </BaseInput>
          <BaseInput placeholder="" title="" @onInput="updateValue" :value="dataForModal.promocodes__ends"
            name-sign="Дата конца" input-name="promocodes__ends" input-type="datetime-local">
          </BaseInput>

          <div class="d-flex gap-10 mt-15">
            <div class="btn btn-sm btn-primary" @click="sendDataFromModal">
              {{ dataLang.form_btn__btn_save }}
            </div>
            <div class="btn btn-sm btn-opposite" @click="btnHandlerCloseModal">
              {{ dataLang.form_btn__btn_caneсl }}
            </div>
          </div>
        </div>
      </Modal>
      <Modal nameForAction="acceptDelete">
        <p class="text-center">{{ dataLang.confirm_dialog_delete }}</p>
        <div class="d-flex justify-content-center mt-10">
          <div class="btn btn-sm btn-danger" @click="deleteRow('acceptDelete')">
            Да
          </div>
        </div>
      </Modal>
    </Teleport>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import Modal from '@/components/Modals.vue'
import EventBus from '@/event-bus.js'
import BaseTextarea from '@/components/ui/BaseTextarea.vue'
export default {
  components: {
    Modal,
    BaseTextarea
  },

  props: {},
  data() {
    return {
      updatedValues: {},
      dataForModal: {},
      editData: {},
      activeSelectRow: null
    }
  },
  methods: {
    clickLoadData(numPage) {
      this.getPromocodesAdminAll({
        params: {
          limit: 10,
          page: numPage
        }
      })
    },
    openModalForCreate(nameModal) {
      EventBus.$emit('openModal', {
        data: null,
        nameForAction: nameModal,
        mode: 'create'
      })
    },

    deleteActionAndModal() {
      if (this.activeSelectRow) {
        EventBus.$emit('openModal', {
          data: null,
          nameForAction: 'acceptDelete',
          mode: 'create'
        })
      } else {
        this.$toast.error('Вы не выбрали ни одного поля', { duration: 5000 })
      }
    },
    deleteRow(nameModal) {
      this.deletePromocodesAdminData(this.activeSelectRow)
      this.activeSelectRow = null
      EventBus.$emit('closeModal', { nameForAction: nameModal })
    },

    sendDataFromModal() {
      if (this.dataForModal.promocodes__id) {
        this.editPromocodesAdminMultiple({
          id: this.dataForModal.promocodes__id,
          dataEdit: this.updatedValues
        })
        EventBus.$emit('closeModal', { nameForAction: 'promocodesAdminModal' })
      } else {
        this.createPromocodesAdminData(this.updatedValues)
        // this.$refs[promocodesAdminModal].$el.querySelectorAll('input').forEach(elem => {
        //     elem.value = ''
        // })

        EventBus.$emit('closeModal', { nameForAction: 'promocodesAdminModal' })
      }
    },

    updateValue(data) {
      this.updatedValues[data.name] = data.value
    },

    prepareKeysForModal(payloadData) {
      this.updatedValues = {}
      this.dataForModal = {}
      if (!payloadData) {
        for (const key in this.promocodesAdminData[0]) {
          this.dataForModal[key] = null
        }
      } else {
        this.dataForModal = Object.assign({}, payloadData)
      }
    },

    closeModal(data) {
      this.activeSelectRow = {}
      this.dataForModal = {}
      // this.$refs[data.nameForAction].$el.querySelectorAll('input').forEach(element => {
      //     element.value = ''
      // })
    },
    btnHandlerCloseModal(nameModal) {
      EventBus.$emit('closeModal', { nameForAction: 'promocodesAdminModal' })
    },

    ...mapActions('promocodesAdminModule', [
      'getPromocodesAdminAll',
      'createPromocodesAdminData',
      'editPromocodesAdminMultiple',
      'deletePromocodesAdminData',
      'setPromocodesAdminRoute'
    ])
  },
  mounted() {
    EventBus.$on('openModal', (payload) => {
      this.editData = payload.data

      this.prepareKeysForModal(payload.data)
    })
    EventBus.$on('selectTableRows', (payload) => {
      this.activeSelectRow = payload.data.promocodes__id
    })
    EventBus.$on('deselectTableRows', (payload) => {
      this.activeSelectRow = null
    })
  },

  created() {
    this.getPromocodesAdminAll({ params: { page: 1, limit: 10 } })
  },
  computed: {
    ...mapState('promocodesAdminModule', [
      'promocodesAdminData',
      'promocodesAdminLoadStatus',
      'paginationPromocodesAdminStateParams'
    ]),
    ...mapState('translationModule', ['dataLang']),
    ...mapGetters('promocodesAdminModule', ['numPages']),

    fieldsTablePromocodesAdmin() {
      return [
        { title: 'ID', field: 'promocodes__id', headerFilter: 'input' },
        { title: 'Код', field: 'promocodes__code', headerFilter: 'input' },
        {
          title: 'Описание',
          field: 'promocodes__description',
          headerFilter: 'input'
        },
        {
          title: 'Дата начала',
          field: 'promocodes__starts',
          headerFilter: 'input'
        },
        {
          title: 'Дата конца',
          field: 'promocodes__ends',
          headerFilter: 'input'
        }
      ]
    }
  }
}
</script>
